<div class="content" [formGroup]="filtrosForm">
  <!-- Tipo de Dispositivo -->
  <mat-form-field>
    <mat-label>Tipo de Dispositivo</mat-label>
    <mat-select
      placeholder="Selecciona el tipo de dispositivo"
      formControlName="dispositivo"
    >
      <mat-option
        *ngFor="let dispositivo of configuracionDispositivos | keyvalue"
        [value]="dispositivo.value"
        >{{ dispositivo.value.id }}</mat-option
      >
    </mat-select>
  </mat-form-field>

  <!-- Estatus -->
  <mat-form-field>
    <mat-label>Estatus</mat-label>
    <mat-select
      formControlName="estatus"
      placeholder="Seleccione el estatus"
      multiple
    >
      <mat-option *ngFor="let estado of estados" [value]="estado">{{
        estado
      }}</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Tipo de Equipo -->
  <mat-form-field>
    <mat-label>Tipo de Equipo</mat-label>
    <mat-select
      formControlName="tipoEquipo"
      placeholder="Seleccione el tipo de equipo"
      [disabled]="cargandoTipos"
      multiple
    >
      <mat-option *ngFor="let item of tiposDispositivos" [value]="item.id">{{
        item.name
      }}</mat-option>
    </mat-select>

    <mat-spinner *ngIf="cargandoTipos" matSuffix diameter="24"></mat-spinner>
  </mat-form-field>

  <!-- Modelo -->
  <mat-form-field>
    <mat-label>Modelo</mat-label>
    <mat-select
      formControlName="modelo"
      placeholder="Seleccione el modelo"
      [disabled]="cargandoModelos"
      multiple
    >
      <mat-option *ngFor="let item of modelos" [value]="item.id">{{
        item.name
      }}</mat-option>
    </mat-select>

    <mat-spinner *ngIf="cargandoModelos" matSuffix diameter="24"></mat-spinner>
  </mat-form-field>

  <!-- Marca -->
  <mat-form-field>
    <mat-label>Marca</mat-label>
    <mat-select
      formControlName="marca"
      placeholder="Seleccione la marca"
      [disabled]="cargandoFabricantes"
      multiple
    >
      <mat-option *ngFor="let item of fabricantes" [value]="item.id">{{
        item.name
      }}</mat-option>
    </mat-select>

    <mat-spinner
      *ngIf="cargandoFabricantes"
      matSuffix
      diameter="24"
    ></mat-spinner>
  </mat-form-field>

  <!-- Etiqueta -->
  <!-- <mat-form-field>
    <mat-label>Etiqueta</mat-label>
    <input
      matInput
      formControlName="etiqueta"
      placeholder="Ingrese la etiqueta"
    />
  </mat-form-field> -->
  <!-- No. Serie -->
  <!-- <mat-form-field>
    <mat-label>No. Serie</mat-label>
    <input
      matInput
      formControlName="numSerie"
      placeholder="Ingrese el número de serie"
    />
  </mat-form-field> -->
  <!-- Colaborador Asignado -->
  <!-- <mat-form-field>
    <mat-label>Colaborador Asignado</mat-label>
    <input
      matInput
      formControlName="colaboradorAsignado"
      placeholder="Ingrese el nombre del colaborador"
    />
  </mat-form-field> -->
  <!-- Fecha de Asignación -->
  <!-- <mat-form-field>
    <mat-label>Fecha de Asignación</mat-label>
    <mat-date-range-input
      [rangePicker]="pickerAsignacion"
      formGroupName="fechaAsignacion"
    >
      <input matStartDate formControlName="inicio" placeholder="DD/MM/YYYY" />
      <input matEndDate formControlName="fin" placeholder="DD/MM/YYYY" />
    </mat-date-range-input>

    <mat-datepicker-toggle
      matSuffix
      [for]="pickerAsignacion"
    ></mat-datepicker-toggle>
    <mat-date-range-picker #pickerAsignacion>
      <mat-date-range-picker-actions>
        <button mat-button matDateRangePickerCancel>Cancelar</button>
        <button mat-raised-button color="primary" matDateRangePickerApply>
          Aplicar
        </button>
      </mat-date-range-picker-actions>
    </mat-date-range-picker>
  </mat-form-field> -->
  <!-- Fecha de Alta -->
  <!-- <mat-form-field>
    <mat-label>Fecha de Alta</mat-label>
    <mat-date-range-input [rangePicker]="pickerAlta" formGroupName="fechaAlta">
      <input matStartDate formControlName="inicio" placeholder="DD/MM/YYYY" />
      <input matEndDate formControlName="fin" placeholder="DD/MM/YYYY" />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="pickerAlta"></mat-datepicker-toggle>
    <mat-date-range-picker #pickerAlta>
      <mat-date-range-picker-actions>
        <button mat-button matDateRangePickerCancel>Cancelar</button>
        <button mat-raised-button color="primary" matDateRangePickerApply>
          Aplicar
        </button>
      </mat-date-range-picker-actions>
    </mat-date-range-picker>
  </mat-form-field> -->
  <!-- Fecha de Baja -->
  <!-- <mat-form-field>
    <mat-label>Fecha de Baja</mat-label>
    <mat-date-range-input [rangePicker]="pickerBaja" formGroupName="fechaBaja">
      <input matStartDate formControlName="inicio" placeholder="DD/MM/YYYY" />
      <input matEndDate formControlName="fin" placeholder="DD/MM/YYYY" />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="pickerBaja"></mat-datepicker-toggle>
    <mat-date-range-picker #pickerBaja>
      <mat-date-range-picker-actions>
        <button mat-button matDateRangePickerCancel>Cancelar</button>
        <button mat-raised-button color="primary" matDateRangePickerApply>
          Aplicar
        </button>
      </mat-date-range-picker-actions>
    </mat-date-range-picker>
  </mat-form-field> -->
</div>

<div class="actions">
  <button
    mat-raised-button
    color="primary"
    (click)="aplicarFiltros()"
    [disabled]="disabled"
  >
    Aplicar
  </button>
  <button mat-button (click)="limpiarFiltros()">Restablecer</button>
</div>
